import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { WhatsIncludedSection } from './components/WhatsIncludedSection';
import { BonusEbooksSection } from './components/BonusEbooksSection';
import { CategoriesSection } from './components/CategoriesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { CustomerResultsSection } from './components/CustomerResultsSection';
// import { RecommendedFryerSection } from './components/RecommendedFryerSection' // Guardada para reactivar después
import { GuaranteeSection } from './components/GuaranteeSection';
import { PricingSection } from './components/PricingSection';
import { FaqSection } from './components/FaqSection';
import { Footer } from './components/Footer';
import { CartProvider } from './context/CartContext';
import { CheckoutCart } from './components/CheckoutCart';
import { SocialProofPopup } from './components/SocialProofPopup';
import { SocialProofBanner } from './components/SocialProofBanner';
import { StickyMobileCTA } from './components/StickyMobileCTA';
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    const pixelId = '3110428549165135';
    if (!(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    ;
    (window as any).fbq('init', pixelId);
    (window as any).fbq('track', 'PageView');
  }, []);
  return <CartProvider data-id="element-0">
      <div className="min-h-screen bg-background w-full flex flex-col overflow-x-hidden" data-id="element-1">
        <SocialProofBanner data-id="element-2" />
        <HeroSection data-id="element-3" />
        <PricingSection id="oferta" data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <WhatsIncludedSection data-id="element-6" />
        <BonusEbooksSection data-id="element-7" />
        <CategoriesSection data-id="element-8" />
        <TestimonialsSection data-id="element-9" />
        <CustomerResultsSection data-id="element-10" />
        <GuaranteeSection data-id="element-11" />
        <FaqSection data-id="element-12" />
        <PricingSection showPaymentLogos={false} data-id="element-13" />
        <Footer data-id="element-14" />
        <CheckoutCart data-id="element-15" />
        <SocialProofPopup data-id="element-16" />
        <StickyMobileCTA data-id="element-17" />
      </div>
    </CartProvider>;
}